import { forwardRef } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import Icon from '@/components/icon'
import { createModal, useModalize } from '@/components/modalize/mui'
import { EquifaxLogo } from '@/components/icons'
import useMediaQuery from '@/hooks/use-media-query'
import { breakpoints } from '@/styles'
import {
  Wrapper,
  ModalClose,
  ContentWrapper,
  TitleContainer,
  Title,
  EquifaxContainer,
  PoweredByText
} from './modal-elements'
import { getModalInfo } from './get-modal-info'

const StyledEquifaxLogo = styled(EquifaxLogo)`
  max-width: 100px;
`

const InfoModal = forwardRef(
  ({ title, content, mobileContent, isPoweredByEquifax = false }, ref) => {
    const { close } = useModalize()
    const { t } = useTranslation()
    const isMobile = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`)
    const showMobileContent =
      useMediaQuery(`(max-width: ${breakpoints.phoneMax})`) && !!mobileContent

    return (
      <>
        <Wrapper ref={ref}>
          {!isMobile && (
            <ModalClose>
              <Icon aria-label="Close" id="close" width={24} height={24} onClick={close} />
            </ModalClose>
          )}
          <TitleContainer isDesktop={!isMobile}>
            <Title>{title}</Title>
            {isPoweredByEquifax && (
              <EquifaxContainer>
                <PoweredByText>
                  {t('l.application.view.powered_by.text', 'Powered By')}:
                </PoweredByText>
                <StyledEquifaxLogo />
              </EquifaxContainer>
            )}
          </TitleContainer>
          <ContentWrapper>{showMobileContent ? mobileContent : content}</ContentWrapper>
        </Wrapper>
      </>
    )
  }
)

InfoModal.displayName = 'InfoModal'

export default InfoModal

const showInfoModal = createModal(InfoModal, {
  width: 'auto',
  maxWidth: '767px',
  sheet: true,
  hasHeader: false
})

export { showInfoModal, getModalInfo }
